import React from 'react';
import { Card, Button, CloseButton } from '../design-system';

const CardDetailsModal = ({ card, isCollected, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[60] p-4">
      <Card 
        variant="elevated" 
        padding="large" 
        className="max-w-md w-full text-center"
      >
        <div className="flex flex-col items-center space-y-6">
          {/* Close Button */}
          <div className="self-end">
            <CloseButton
              onClick={onClose}
              className="p-2 text-gray-400 hover:text-gray-600"
            />
          </div>

          {isCollected ? (
            <>
              {/* Collected Card - Show Full Image */}
              <div className="w-full aspect-[3/4] relative overflow-hidden rounded-lg">
                <img
                  src={card.imageUrl}
                  alt={card.name}
                  className="w-full h-full object-cover"
                />
              </div>
              
              {/* Card Info */}
              <div className="space-y-3">
                <h2 className="text-2xl font-bold text-gray-900">
                  {card.name}
                </h2>
                <p className="text-gray-600">
                  {card.description}
                </p>
                {card.motivationalMessage && (
                  <div 
                    className="p-4 rounded-lg"
                    style={{ 
                      backgroundColor: card.colorScheme?.primary + '20',
                      border: `2px solid ${card.colorScheme?.primary}`
                    }}
                  >
                    <p className="text-sm font-medium" style={{ color: card.colorScheme?.primary }}>
                      {card.motivationalMessage}
                    </p>
                  </div>
                )}
              </div>
            </>
          ) : (
            <>
              {/* Uncollected Card - Show Locked State */}
              <div className="w-full aspect-[3/4] relative overflow-hidden rounded-lg bg-gray-200 flex items-center justify-center">
                <div className="text-center">
                  <svg 
                    className="w-24 h-24 text-gray-400 mx-auto mb-4" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                  <p className="text-gray-500 font-medium">Card Locked</p>
                </div>
              </div>
              
              <div className="space-y-3">
                <h2 className="text-2xl font-bold text-gray-400">
                  {card.name}
                </h2>
                <p className="text-gray-500">
                  Complete more tasks to unlock this card!
                </p>
              </div>
            </>
          )}

          {/* Close Button */}
          <Button
            variant="primary"
            size="medium"
            onClick={onClose}
            className="w-full md:w-auto px-8"
          >
            Close
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default CardDetailsModal;

